export default function () {
  const companyFormGroup = document.querySelector('#form-group-kontaktFormular-83-text-1')
  const salutationCompany = document.querySelector('#kontaktFormular-83-radiobutton-1-3')
  const salutationRadios = document.querySelectorAll('#kontaktFormular-83-radiobutton-1 input')
  const hiddenFormGroupClass = 'form__group--hidden'

  checkCompanyHide()

  salutationRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      checkCompanyHide()
    })
  }, false)

  function checkCompanyHide () {
    if (companyFormGroup) {
      if (!salutationCompany.checked) {
        companyFormGroup.classList.add(hiddenFormGroupClass)
      } else {
        companyFormGroup.classList.remove(hiddenFormGroupClass)
      }
    }
  }
}
